
import Title from '../utils/Title'


export default function HomePage() {
	return <>
		<Title>Home</Title>
	</>
}